import { render, staticRenderFns } from "./PropertiesInfo.vue?vue&type=template&id=0590a93b&scoped=true&"
import script from "./PropertiesInfo.vue?vue&type=script&lang=js&"
export * from "./PropertiesInfo.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesInfo.vue?vue&type=style&index=0&id=0590a93b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0590a93b",
  null
  
)

export default component.exports